export default new class resetForm {
  constructor() {
    this.resetFormSelector = 'reset__form';
    this.resetEmailInput = 'reset__email';
    this.submitBtnSelector = 'reset__submit';
    this.inValidSelector = '_invalid';
    this.successSelector = 'reset__success';
    this.successVisibleSelector = 'reset__success_visible';
    this.preLoaderSelector = 'reset__preloader';
    this.delay = 2000;

    this.handler();
  }

  handler() {
    const form = document.querySelector(`.${this.resetFormSelector}`);

    if (!form) return;

    const submitBtn = form.querySelector(`.${this.submitBtnSelector}`);

    submitBtn.addEventListener('click', () => {
      setTimeout(() => {
        this.checkForm(form);
      }, 0);
    });
  }

  checkForm(form) {
    if (form.matches(`.${this.inValidSelector}`)) return;

    const formEmail = form.querySelector(`.${this.resetEmailInput}`);
    const email = formEmail.value;

    $.request('RestorePassword::onAjax', {
      data: {
        email,
      },
      loading: `.${this.preLoaderSelector}`,
      complete: (res) => {
        this.showTooltip(res);
      },
    });
  }

  showTooltip(res) {
    clearTimeout(this.timer);
    const { responseJSON } = res;

    if (!responseJSON.message) return;

    const tooltip = document.querySelector(`.${this.successSelector}`);
    tooltip.classList.add(this.successVisibleSelector);
    if (!responseJSON.status) {
      tooltip.classList.add('tooltip__error');
    } else {
      tooltip.classList.remove('tooltip__error');
    }
    tooltip.innerHTML = responseJSON.message;

    this.timer = setTimeout(() => {
      tooltip.classList.remove(this.successVisibleSelector);
    }, 2000);
  }
}();
